export const DEFAULT_STYLE_OPTIONS = [{
  bindTo: 'baseColor',
  label: 'Metric Color',
  type: 'color'
}, {
  bindTo: 'backgroundColor',
  label: 'Background Color',
  type: 'color'
}, {
  bindTo: 'textColor',
  label: 'Text Color',
  type: 'color'
}]

export const DEFAULT_OPTIONS = [{
  bindTo: 'title',
  label: 'Title',
  type: 'textFormat',
  options: [{
    bindTo: 'text'
  }, {
    bindTo: 'align'
  }, {
    bindTo: 'size'
  }]
}]